/**
 * "Changed on the server" as a visible alert (UI/UX fix round A, review U18) — it used to be small grey text beside an
 * enabled-looking Save. Save stays off until the section is reloaded, and the notice says that reloading replaces the
 * section's unsaved edits.
 */
import { AlertTriangle } from 'lucide-react';
import { Button } from '../../../../components/ui/button';

export function PropertiesConflictNotice({ message, onReload, reloading = false, testId }: { message: string; onReload: () => void; reloading?: boolean; testId: string }) {
  return (
    <div role="alert" className="flex items-start gap-2 rounded-md border border-warning/40 bg-warning/10 p-2 text-xs text-foreground" data-testid={`${testId}-conflict`}>
      <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0 text-warning" aria-hidden="true" />
      <span className="min-w-0 flex-1">{message}</span>
      {/* F20 (last UI/UX pass): off while a reload runs, like the panel's own Reload. */}
      <Button type="button" size="xs" variant="outline" disabled={reloading} title={reloading ? 'Reloading…' : undefined} data-testid={`${testId}-reload`} onClick={onReload}>Reload</Button>
    </div>
  );
}
